import {useMutation} from '@apollo/react-hooks';

import type {
    CreateAccountForCoreEntity as CreateAccountForCoreEntityMutation,
    CreateAccountForCoreEntityVariables as CreateAccountForCoreEntityMutationVariables,
    AccountCreateInput,
} from 'nutshell-graphql-types';

import CREATE_ACCOUNT_FOR_CORE_ENTITY from '../mutations/create-account-for-core-entity.graphql';

interface CreateAccountForCoreEntityOptions {
    refetchQueries: any[];
}

export function useCreateAccountForCoreEntity(options?: CreateAccountForCoreEntityOptions): {
    createAccountForCoreEntity: (input: AccountCreateInput) => Promise<any>;
    isLoading: boolean;
} {
    const [createAccountForCoreEntity, {loading}] = useMutation<
        CreateAccountForCoreEntityMutation,
        CreateAccountForCoreEntityMutationVariables
    >(CREATE_ACCOUNT_FOR_CORE_ENTITY);

    return {
        createAccountForCoreEntity: (input: AccountCreateInput) => {
            return createAccountForCoreEntity({
                variables: {input},
                refetchQueries: options?.refetchQueries,
                awaitRefetchQueries: true,
            });
        },
        isLoading: loading,
    };
}
